module.exports = __webpack_public_path__ + "static/media/register.0c766477.svg";